export const I18N_SEE_MORE = 'generic.see_more';
export const I18N_SEE_LESS = 'generic.see_less';
export const COLLAPSIBLE_DIV_CLASS = 'grouping-selections__see-more';
export const COLLAPS_TEXT_CLASS = 'grouping-selections__collapse';

